import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { Meter, Site } from "../../../../../utils/backend-types";
import type { SiteName } from "../../../../../utils/enums";
import type { SelectedMeter } from "../../../EditConfigurationModal/EditConfigurationModal";
import type { MeterConfigurationData } from "../../../ThirdPartySystems.types";
import { MeterSelectionCell } from "../../MeterSelectionCell/MeterSelectionCell";

declare const SITE_NAME: SiteName;

function getOptiNodeMeterColumn(
  metersBySiteId: Array<Meter>,
  selectedMeters: Array<SelectedMeter>,
  sites: Array<Site>,
  handleSelectMeter: (entityId: number, meterId: number) => void,
  handleRemoveMeter: (entityId: number) => Promise<void>,
  onMetersSave: (singleEntityId?: number) => Promise<{ success: boolean }>
): MRT_ColumnDef<MeterConfigurationData> {
  return {
    header: `Zähler (${SITE_NAME})`,
    accessorKey: "meter",
    size: 250,
    Cell: ({ row }) => (
      <MeterSelectionCell
        meterParameter={row.original}
        metersBySiteId={metersBySiteId}
        selectedMeters={selectedMeters}
        sites={sites}
        onChange={(value) =>
          handleSelectMeter(row.original.id as number, Number(value))
        }
        onMeterRemove={handleRemoveMeter}
        onMeterSave={onMetersSave}
      />
    )
  };
}

export { getOptiNodeMeterColumn };
